<template>
    <div id="cesiumContainer"></div>
</template>

<script>
    import * as Cesium from "cesium/Cesium";
    import widget from "cesium/Widgets/widgets.css";

    export default {
        name: "CesiumScene",
        data() {
            return {
                vw: null,
                date: Date.now()
            };
        },
        mounted() {
            this.init();
        },
        beforeDestroy() {
        },
        methods: {
            init() {
                let viewerOption = {
                    geocoder: false, // 地理位置查询定位控件
                    homeButton: false, // 默认相机位置控件
                    timeline: false, // 时间滚动条控件
                    navigationHelpButton: false, // 默认的相机控制提示控件
                    fullscreenButton: false, // 全屏控件
                    scene3DOnly: true, // 每个几何实例仅以3D渲染以节省GPU内存
                    baseLayerPicker: false, // 底图切换控件
                    animation: false, // 控制场景动画的播放速度控件
                    shouldAnimate: true,
                    //关闭星星
                    skyBox: new Cesium.SkyBox({
                        show: true
                    }),
                };
                let viewer = new Cesium.Viewer(this.$el, viewerOption);

                viewer.scene.sun.destroy(); //去掉太阳
                viewer.scene.sun = undefined; //去掉太阳
                viewer.scene.moon.destroy(); //去掉月亮
                viewer.scene.moon = undefined; //去掉月亮

                this.vw = viewer;
                viewer._cesiumWidget._creditContainer.style.display = "none";// 隐藏版权
                // viewer.clock.onTick.addEventListener(this.rotate);
            },
            //问题：越转越快了
            rotate() {
                console.log("进入rotate");
                let viewer = this.vw;
                let i = this.date;
                let a = .1;
                let t = Date.now();
                let n = (t - i) / 1e5;
                i = t;
                viewer.scene.camera.rotate(Cesium.Cartesian3.UNIT_Z, -a * n);
            }
        }
    };
</script>

<style lang='less' scoped>
    #cesiumContainer {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
</style>
